<div class="edit-settings-root" *transloco="let t">
  <app-header>{{t('change-system-language')}}</app-header>
  <div class="radio-button">
    <input type="radio"
           id="english-language"
           name="system-language"
           value="en"
           [formControl]="languageControl">
    <label for="english-language">{{t('english')}}</label>
  </div>
  <div class="radio-button">
    <input type="radio"
           id="portuguese-language"
           name="system-language"
           value="pt"
           [formControl]="languageControl">
    <label for="portuguese-language">{{t('portuguese')}}</label>
  </div>
  <div class="radio-button">
    <input type="radio"
           id="spanish-language"
           name="system-language"
           value="es"
           [formControl]="languageControl">
    <label for="spanish-language">{{t('spanish')}}</label>
  </div>
  <app-primary-button (clickAction)="saveSettingsChanges()" [disabled]="isFormDisabled() || loading">{{t('save-settings-changes')}}</app-primary-button>
</div>
<div class="loading-container"
*ngIf="loading">
  <mat-spinner
  [diameter]="60"
  class="spinner"></mat-spinner>
</div>
